"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompanyTypes = exports.CompanyStatus = void 0;

var common_1 = require("./common");

var CompanyStatus;

(function (CompanyStatus) {
  CompanyStatus["ACTIVE"] = "active";
  CompanyStatus["BANNED"] = "banned";
  CompanyStatus["DELETED"] = "deleted";
  CompanyStatus["PENDING_VERIFICATION"] = "pending_verification";
  CompanyStatus["REJECTED_WITH_RETRY_ALLOWED"] = "rejected_with_retry_allowed";
  CompanyStatus["STARTED_VERIFICATION"] = "started_verification";
  CompanyStatus["MANUAL_REVIEW_REQUIRED"] = "manual_review_required";
})(CompanyStatus = exports.CompanyStatus || (exports.CompanyStatus = {}));

var CompanyTypes;

(function (CompanyTypes) {
  CompanyTypes["SOLE_TRADER"] = "sole_trader";
  CompanyTypes["COMPANY"] = "company";
})(CompanyTypes = exports.CompanyTypes || (exports.CompanyTypes = {}));